<template lang="pug">
  section.dashboard
    .heading-actions
      h1.page-title Referral Report
      .actions
        .custom-select
          select(v-model="daysFilter" @change="getReport()")
            option(value="") All Time
            option(value="30") Last 30 Days
            option(value="60") Last 60 Days
            option(value="90") Last 90 Days
            option(value="180") Last 6 Months
            option(value="365") Last 12 Months
    div(id="container")
      table.report-list
        thead
          tr
            th Referrer
            th Total Referrals
            th Converted
            th Conversion Rate
            th
        tbody
          tr(v-if="!referralReport || referralReport.length === 0")
            td(colspan="5")
              | No referrals to display
          tr(v-for="r in referralReport")
            td {{ r.referrerName }}
            td {{ r.referralCount }} {{ r.referralCount == 1 ? 'User' : 'Users'}}
            td {{ r.closedCount }}
            td
              .progress-percent {{ Math.round(r.closeRate * 100) }}%
              .progress-bar
                span.progress(v-bind:style="{width : Math.round(r.closeRate*100) + '%'}")
            td.action
              button.btn.small(@click="goToList(r.referrerName)" :disabled="r.closedCount === 0") View List
    nav.pagination
      ul.pagination-wrapper
        li
          //- p Page&nbsp;
          //-   strong 1&nbsp;
          //-   | of 12
        li
          ul.pagination-links
            li.prev(v-bind:class="{ disabled: hidePrevious }" @click="onPrevious()")
              a(href="#") &lt; Prev
            li.next(v-bind:class="{ disabled: hideNext }" @click="onNext()")
              a(href="#") Next &gt;
</template>

<script>
import PatientPagination from './patient/PatientPagination.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Reports',
  data() {
    return {
      pageSize: 100,
      page: 1,
      daysFilter: ''
    };
  },
  components: {
    PatientPagination
  },
  computed: {
    hidePrevious: function() {
      return this.page === 1;
    },
    hideNext: function() {
      // TODO: Calculate this more precisely when API returns info about whether we are on last page
      return this.referralReport.length < this.pageSize;
    },
    ...mapGetters([
      'referralReport'
    ])
  },
  methods: {
    onPrevious() {
      this.page--;
      this.getReport();
    },
    onNext() {
      this.page++;
      this.getReport();
    },
    getReport() {
      const offset = (this.page - 1) * this.pageSize;
      const params = { rowcount: this.pageSize, offset: offset, daysAgo: this.daysFilter };
      this.getReferralReport(params).then(() => {
        let container = document.getElementById('container');
        container.scrollTop = 0;
      });
    },
    goToList(referrerName) {
      // clear existing filters
      this.setPatientFilters();
      // add new one
      this.setPatientFilters({referrers: [ referrerName ]});
      this.$router.push({name: 'Dashboard'});
    },
    ...mapMutations([
      'setPatientFilters'
    ]),
    ...mapActions([
      'getReferralReport'
    ])
  },
  created() {
    this.getReport();
  }
};
</script>

<style lang="scss" scoped>
  .heading-actions {
    width: 100%;
    margin: 0 auto $base-spacing;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .page-title {
      margin-bottom: 0;
      max-width: 50%;
    }
    .actions {
      max-width: 50%;
    }
  }
  .report-list {
    width: 100%;
    margin: 0 0 $base-spacing 0;
    border: 1px solid $base-border-color;
    border-bottom: none;
    border-collapse: separate;
    border-spacing: 0;
    th, td {
      border: none;
      padding: $base-spacing $small-spacing;
      line-height: 1.2;
      font-size: $base-font-size;
      white-space: pre-wrap;
      vertical-align: top;
    }
    .action {
      text-align: right;
    }
    thead th {
      background: #fff;
      border-bottom: 1px solid $base-font-color;
    }
    tbody td {
      border-bottom: 1px solid $base-border-color;
    }
    tbody tr:nth-child(2n) {
      background: #fff;
    }
  }
  .progress-percent {
    @include zero;
    line-height: 1;
    display: inline-block;
    vertical-align: middle;
    font-weight: $base-font-weight-strong;
    min-width: 3em;
    text-align: right;
  }
  .progress-bar {
    display: inline-block;
    position: relative;
    margin-left: $small-spacing;
    width: 100px;
    height: 6px;
    background: #fff;
    border: 1px solid $success-color;
    .progress {
      @include position(absolute, 0 null 0 0);
      display: block;
      height: 4px;
      background-image: linear-gradient(to right, lighten($success-color, 20%), $success-color);
    }
  }
  nav.pagination {
    margin: $base-spacing auto;
    padding: 0;
  }
  .pagination-wrapper {
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }

  .pagination-links {
    @include zero;
      background: #fff;
      border: 1px solid $base-border-color;
      border-radius: $base-border-radius;
    li {
      display: inline-block;
    }
    li.current {
      padding: $xs-spacing $small-spacing;
      background: $base-border-color;
      color: #fff;
    }
    li.disabled {
      pointer-events: none;
      opacity: 0.5;
      a {
        color: $grey;
      }
    }
    a {
      display: block;
      padding: $xs-spacing $small-spacing;
      &:hover, &:focus {
        background: $action-color;
        color: #fff;
      }
    }
  }

</style>
